import React, {
  useMemo,
  useRef,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import s from "./style.module.scss";
import { actions as surveyActions } from "../../../modules/survey";
import { actions as submissionEditActions } from "../../../modules/submissionEdit";
import { actions as pageInfoActions } from "../../../modules/pageInfo";
import { Redirect } from "react-router-dom";
import getPath from "../../../services/getPath";
import Loading from "../../pres/Loading/index.jsx";
import InactiveSurveyMessage from "../../pres/InactiveSurveyMessage";
import RenderGreetings from "../../pres/RenderGreetings";
import RenderSurveyInGuidedMode from "../../pres/RenderSurveyInGuided";
import RenderSurveyInClassicMode from "../../pres/RenderSurveyInClassic";
import ConditionalSurvey from "../../pres/ConditionalSurvey";
import SurveyErrorState from "../../pres/SurveyErrorState";
import SurveyAlreadyTakenState from "../../pres/SurveyAlreadyTakenState";
import {
  CACHE_SURVEY_RESPONSE_KEY,
  EQUATION,
} from "../../../services/constants";
import {
  SURVEY_DELETED_ERROR_MESSAGE,
  SURVEY_DEACTIVATED_ERROR_MESSAGE,
  SURVEY_SOMETHING_WRONG_MESSAGE,
  SURVEY_INVALID_PARAMS_MSG,
} from "../../../modules/constants";
import {
  fetchCustomVariableOptionsFromAnswers,
  fetchEquationVariableOptionsFromAnswers,
  fetchPTLOptionsFromAnswers,
  trackPageView,
} from "../../../services/commons";
import {
  FORMATING_TYPE,
  TRACK,
  THEME_WALMART_CLASSIC,
  CONDITIONS,
  START_OVER,
  RESUME,
  QUESTION_TYPES,
} from "../../constants";
import config from "../../../config/config";
import i18next from "i18next";
import {
  transformPTLsFromURL,
  isPTLinURLBroken,
  fetchCustomerDetailsFromURL,
} from "../../../utils/ptlTransformation";
import AutoSaveModal from "../../pres/AutoSaveModal";
import { actions as autoSaveActions } from "../../../modules/autoSave";
import { mediaUploadSubmitFile } from "../../../services/api/index.js";
const localStorage = require("localStorage");

if (!Object.values) {
  Object.values = (o) => Object.keys(o).map((k) => o[k]);
}

const SurveyAnswer = (props) => {
  const { t } = useTranslation("surveyTaker");
  const dispatch = useDispatch();
  const {
    surveyExperienceType,
    previewUnAuthorized,
    requestCompleted,
    alreadyTaken,
    greetings,
    data: survey,
  } = useSelector((state) => state.survey);
  const { surveyDeleted, surveyDeactivated, saveInProgress, lastSavedId } =
    useSelector((state) => state.submissionEdit);
  const { spent_time: prevSpentTime, currentLang: autoSaveCurrentLang } =
    useSelector((state) => state.autoSave.data);
  const { requestCompleted: autoSaveLoaded, dataExist: autoSaveExist } =
    useSelector((state) => state.autoSave);

  const { id: surveyId, encodedValues } = props.match.params;
  const pageNameUpdated = useRef(false);
  const displayQuestionTracked = useRef(false);
  const startTime = useRef(new Date().getTime() / 1000);
  const previousLang = useRef(i18next.language);
  const scrollHeight = useRef(document.body.scrollHeight);
  const [welcomeDone, setWelcomeDone] = useState(false);
  const [modifiedOn, setModifiedOn] = useState(null);
  const [anonymousAccess, setAnonymousAccess] = useState(false);
  const [answers, setAnswers] = useState({});
  const [previewSubmission, setPreviewSubmission] = useState(false);
  const [hasConditions, setHasConditions] = useState(false);
  const [hasAnswerOptionLogic, setHasAnswerOptionLogic] = useState(null);
  const [hasEquationVariable, setHasEquationVariable] = useState(null);
  const [hasDependentEV, setHasDependentEV] = useState(null);
  const [hasError, setHasError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(SURVEY_SOMETHING_WRONG_MESSAGE);
  const [selectedLanguage, setSelectedLanguage] = useState(
    props.selectedLanguage || ""
  );
  const [autoSaveModalOpen, setAutoSaveModalOpen] = useState(true);
  const [resumeType, setResumeType] = useState();
  const [hasBlocks, setHasBlocks] = useState(false);

  document.title = useMemo(
    () => `Feedback | ${survey?.[surveyId]?.name}`,
    [survey, surveyId]
  );

  const { hiddenAnswers, campaignDetails } = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      hiddenAnswers: transformPTLsFromURL(
        encodedValues,
        window.location.search
      ),
      campaignDetails: fetchCustomerDetailsFromURL(encodedValues, urlParams),
    };
  }, [encodedValues]);

  const { singleLangPreview, previewing, currentLang } = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      singleLangPreview: urlParams.get("singleLangPreview"),
      previewing: urlParams.get("previewing"),
      currentLang: urlParams.get("lang"),
    };
  }, []);

  const dispatchActions = (data) => {
    const { theme, anonymous_access } = data.thirdPartySettings;
    const {
      closingMessage,
      greetings,
      surveyExperienceType,
      greetingsTranslations,
      availableLanguages,
    } = data;
    dispatch(surveyActions.setSurveyTheme(theme));
    dispatch(
      surveyActions.setLandingPageDetails(
        greetings,
        greetingsTranslations,
        availableLanguages
      )
    );
    dispatch(surveyActions.setClosingPageDetails(closingMessage));
    dispatch(surveyActions.setSurveyExperienceType(surveyExperienceType));
    if (
      Object.prototype.hasOwnProperty.call(data, "visibleThemeHeaderNLogo") &&
      data.visibleThemeHeaderNLogo
    ) {
      dispatch(surveyActions.setVisibleThemeHeaderAndLogo(true));
    }
    if (anonymous_access) {
      //incase user modified the survey later to anonymous
      dispatch(autoSaveActions.deleteData(surveyId));
    }
  };

  const updateDimensions = () => {
    if (scrollHeight.current !== document.body.scrollHeight) {
      const message = { height: document.body.scrollHeight };
      scrollHeight.current = document.body.scrollHeight;
      // window.top refers to parent window
      window.top.postMessage(message, "*");
    }
  };
  const submitFileAction = async (blobName, questionLabel) => {
    return await mediaUploadSubmitFile(surveyId, questionLabel, blobName);
  };

  const save = useCallback(
    (queAnswers, pipingAnswers, status) => {
      let ans = _.cloneDeep(queAnswers);
      if (previewing === "true") {
        setPreviewSubmission(true);
      } else {
        // add all PTL answers
        ans = fetchPTLOptionsFromAnswers(
          survey[surveyId].questions,
          answers,
          queAnswers
        );
        if (hasAnswerOptionLogic) {
          ans = fetchCustomVariableOptionsFromAnswers(survey, surveyId, ans);
        }
        if (hasEquationVariable) {
          ans = fetchEquationVariableOptionsFromAnswers(survey, surveyId, ans);
        }
        let surveyResponse = {
          answers: ans,
          surveyId: surveyId,
          startTime: startTime.current - (prevSpentTime || 0) ,
          modified_on: modifiedOn,
          piping_answers: pipingAnswers,
          anonymousAccess: anonymousAccess,
          status: status === "terminate" ? "terminated" : "completed",
        };
        if (campaignDetails?.campaignID?.length > 0) {
          surveyResponse = { ...surveyResponse, ...campaignDetails };
        }
        const mediaUploadNames = Object.values(ans).filter((item) => {
          if (item.questionType === "mediaUpload") {
            const fileNames = item.answers.map((fileData) => fileData.fileUploadName);
            return fileNames;
          }
        });

        const mediaUploadNameArray = mediaUploadNames.map((item) => item.answers);

        const submitFilesArray = mediaUploadNameArray
          .flat(1)
          .filter((item) => item);
        submitFilesArray.forEach((file) => {
          const fileName = file.fileUploadName;
          let fName = fileName?.slice(
            fileName.indexOf("mUQ"),
            fileName.indexOf("-")
          );
          const fileNameToSend = "Q" + fName?.split("Q")[1];
          submitFileAction(fileName, fileNameToSend);
        });
        dispatch(submissionEditActions.submissionEditModify(surveyResponse));
        dispatch(submissionEditActions.submissionEditSave(selectedLanguage));
      }
    },
    [
      previewing,
      selectedLanguage,
      dispatch,
      anonymousAccess,
      modifiedOn,
      surveyId,
      answers,
    ]
  );

  useEffect(() => {
    if (resumeType === RESUME) {
      if(selectedLanguage !== autoSaveCurrentLang)
        initialDataSetupForTakerView(autoSaveCurrentLang);
      
      setSelectedLanguage(autoSaveCurrentLang);
      
    }
  }, [autoSaveCurrentLang, resumeType]);

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);

    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  useEffect(() => {
    initialDataSetupForTakerView(currentLang || selectedLanguage);
    
    return () => {
      dispatch(pageInfoActions.clearPageName());
      //eslint-disable-next-line react-hooks/exhaustive-deps
      i18next.changeLanguage(previousLang.current);
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    updateDimensions();
    if (!pageNameUpdated.current && survey[surveyId]?.name) {
      dispatch(
        pageInfoActions.updatePageName({
          pageName: survey[surveyId].name,
        })
      );
      pageNameUpdated.current = true;
    }

    if (survey[surveyId]?.surveyAuthorized === false) {
      window.location.href = `${
        config.API_ENDPOINT
      }/walmart_sso/redirect?destination="${encodeURI("/survey/" + surveyId)}`;
    }
  });

  useEffect(() => {
    if (!hasConditions) {
      survey?.[surveyId]?.questions?.forEach((question) => {
        const quesCondition = question[CONDITIONS];
        if (quesCondition) {
          if (
            quesCondition.skipConditions?.length > 0 ||
            quesCondition.displayConditions?.length > 0 ||
            quesCondition?.terminateConditions?.length > 0 ||
            question.isPipedFrom
          ) {
            setHasConditions(true);
          }
        }
      });
    }
  }, [hasConditions, survey, surveyId]);

  useEffect(() => {
    if (!hasAnswerOptionLogic) {
      for (let i = 0; i < survey?.[surveyId]?.questions?.length; i++) {
        if (survey?.[surveyId]?.questions[i]?.choices) {
          for (
            let j = 0;
            j < survey?.[surveyId].questions[i].choices?.length;
            j++
          ) {
            if (
              survey?.[surveyId]?.questions[i]?.choices[j]?.logic?.conditions
                ?.length > 0 ||
              survey?.[surveyId]?.questions[i]?.choices[j]?.logic?.check ===
                "alwaysFalse" ||
              survey?.[surveyId]?.questions[i]?.choices[j]?.source
            ) {
              setHasAnswerOptionLogic(true);
            }
          }
        }
      }
    }
  }, [hasAnswerOptionLogic, survey, surveyId]);

  useEffect(() => {
    if (!hasBlocks) {
      survey?.[surveyId]?.questions?.forEach((question) => {
        if (question.type === QUESTION_TYPES.BLOCK) {
          setHasBlocks(true);
        }
      });
    }
  }, [hasBlocks, survey, surveyId]);

  useEffect(() => {
    if (!hasEquationVariable) {
      const questions = survey?.[surveyId]?.questions || [];
      for (const item of questions) {
        if (item.type === EQUATION) {
          setHasEquationVariable(true);
          const dep = item.equations?.some((data) => {
            if (data.type === "function" || data.type === "question") {
              return true;
            }
          });
          if (dep) {
            setHasDependentEV(true);
            break;
          }
        }
      }
    }
  }, [hasEquationVariable, survey, surveyId]);

  const initialDataSetupForTakerView = (lang) => {
    dispatch(surveyActions.setSurveyTheme(THEME_WALMART_CLASSIC));
    i18next.changeLanguage(currentLang);
    dispatch(
      surveyActions.surveyRequestTakerView(
        surveyId,
        previewing === true || previewing === "true" ? true : false,
        lang,
        false,
        campaignDetails
      )
    ).then((data) => {
      if (data && data.surveyExists && data.surveyExists !== false) {
        setModifiedOn(data.modified);
        setAnonymousAccess(data.thirdPartySettings?.anonymous_access);
        loadAutoSaveData(data.thirdPartySettings?.anonymous_access);
        if(!selectedLanguage)
          setSelectedLanguage(currentLang || "en");

        dispatchActions(data);
        //If this is redirection from SSO then get survey response from localStorage and submit
        const cachedSurveyResponse = localStorage.getItem(
          CACHE_SURVEY_RESPONSE_KEY
        );
        if (cachedSurveyResponse && surveyId) {
          const surveyResponse = JSON.parse(cachedSurveyResponse);
          const expiryTime = new Date(surveyResponse.expiryTime);
          if (surveyResponse.survey_id === surveyId) {
            if (new Date().getTime() < expiryTime.getTime()) {
              setWelcomeDone(true);
              dispatch(
                submissionEditActions.submissionEditModify(surveyResponse)
              );
              dispatch(
                submissionEditActions.submissionEditSave(selectedLanguage)
              );
            } else {
              //Survey cached in localStorage has expired so allow user to take survey normally
              localStorage.removeItem(CACHE_SURVEY_RESPONSE_KEY);
            }
          }
        }
        let hasOtherQuestionInPTL;
        const otherPTLQuestionIds = [];
        const questions = data?.questions || [];
        const ptlQuestions = questions.filter(
          (q) =>
            q.formattingType &&
            q.formattingType === FORMATING_TYPE.PASS_THROUGH_LINK
        );
        const hiddenQuestions =
          questions.filter((q) => q.type === "hidden") || [];
        if (
          Object.prototype.hasOwnProperty.call(hiddenAnswers, "hasMobileAuth")
        ) {
          delete hiddenAnswers["hasMobileAuth"];
        }
        const isURLBroken = isPTLinURLBroken(
          [...ptlQuestions, ...hiddenQuestions],
          hiddenAnswers
        );

        if (!previewing && isURLBroken) {
          setHasError(true);
        }
        for (const question of questions) {
          // let surveyTakerError;
          let hiddenAnswer;

          let hiddenVarAnswer = [];
          //adding Hidden variable answers to submission
          if (question.type === "variable") {
            question.choices.forEach((item) => {
              if (
                item.logic.check === "alwaysTrue" ||
                item.logic.check === "trueWithCondition" ||
                item.logic.check === "falseWithCondition"
              ) {
                hiddenVarAnswer.push(item.label);
              }
            });

            if (hiddenVarAnswer.length > 0) {
              setAnswers((prevAns) => {
                return {
                  ...prevAns,
                  [question.id]: hiddenVarAnswer,
                };
              });
            }
            // this.setState((state) => ({
            //   answers:{
            //   ...state.answers,
            //   [question.id]:hiddenVarAnswer
            //   }
            // }));
          }

          if (
            question.formattingType &&
            question.formattingType === FORMATING_TYPE.PASS_THROUGH_LINK
          ) {
            hiddenAnswer = hiddenAnswers[question?.questionLabel]; // Updated to questionLabel instead id
            // surveyTakerError = "surveyTaker:passThroughLinkError";
            //Check if PTL has Other Option
            if (question.other && question.otherQuestionId.length !== 0) {
              hasOtherQuestionInPTL = true;
              otherPTLQuestionIds.push(question.otherQuestionId);
            }
          } else if (question.type === "hidden") {
            hiddenAnswer = hiddenAnswers[question.jsonKey];
            // surveyTakerError = "surveyTaker:hiddenQuestionErrorLog";
          }
          if (
            (question.formattingType &&
              question.formattingType === FORMATING_TYPE.PASS_THROUGH_LINK) ||
            question.type === "hidden"
          ) {
            if (!previewing && !hiddenAnswer && question.required === true) {
              setHasError(true);
              // window.console.error(t(surveyTakerError));
            } else if (
              previewing &&
              !hiddenAnswer &&
              question.required === true
            ) {
              setAnswers((prevAnswers) => {
                return {
                  ...prevAnswers,
                  [question.id]: "dummy answer",
                };
              });
            } else {
              setAnswers((prevAnswers) => {
                return {
                  ...prevAnswers,
                  [question.id]: hiddenAnswer ? hiddenAnswer.toString() : "",
                };
              });
            }
          }
        }
        if (hasOtherQuestionInPTL) {
          otherPTLQuestionIds.forEach((eachPTLQuestionId) => {
            const ptlOtherAnswer = hiddenAnswers[eachPTLQuestionId] || "";
            setAnswers((prevAnswers) => {
              return {
                ...prevAnswers,
                [eachPTLQuestionId]: ptlOtherAnswer
                  ? ptlOtherAnswer.toString()
                  : "",
              };
            });
          });
        }
      } else if (data?.code === "INVALID_PARAMS" && previewing !== "true") {
        setHasError(true);
        setErrorMsg(SURVEY_INVALID_PARAMS_MSG(data?.msg));
      }
    });
  }

  const loadAutoSaveData = (anonymousAccess) => {
    if (!previewing && !anonymousAccess) {
      dispatch(autoSaveActions.requestData(surveyId, campaignDetails));
    } else {
      dispatch(autoSaveActions.requestSuccess());
    }
  }

  const handleValidateQuestion = useCallback(
    (ans) => {
      setAnswers((prevAnswers) => {
        return {
          ...prevAnswers,
          ...ans,
        };
      });

      save({ ...answers, ...ans });
    },
    [answers, save]
  );

  if (!displayQuestionTracked.current) {
    trackPageView(TRACK.PAGE.SURVEYTAKER_QUESTION_DISPLAYED);
    displayQuestionTracked.current = true;
  }

  if (previewSubmission === true || lastSavedId === surveyId) {
    return (
      <div>
        <Redirect
          to={{
            pathname: getPath("/done"),
            state: {
              thirdPartySettings: survey[surveyId].thirdPartySettings,
            },
          }}
        />
      </div>
    );
  }

  if (hasError === true) {
    return <SurveyErrorState message={errorMsg} title={"Oh Snap!"} />;
  }

  if (surveyDeleted === true) {
    return <SurveyErrorState message={SURVEY_DELETED_ERROR_MESSAGE} />;
  }

  if (surveyDeactivated === true) {
    return <SurveyErrorState message={SURVEY_DEACTIVATED_ERROR_MESSAGE} />;
  }

  if (survey?.[surveyId]?.surveyExists === false) {
    return <SurveyErrorState message={t("surveyTaker:surveyDoesNotExist")} />;
  }

  if (
    (previewing === true || previewing === "true") &&
    previewUnAuthorized === true
  ) {
    return <SurveyErrorState message={t("surveyTaker:notAllowedToPreview")} />;
  }

  if (alreadyTaken === true) {
    return (
      <SurveyAlreadyTakenState
        surveyId={surveyId}
        campaignDetails={campaignDetails}
      />
    );
  }

  if (
    survey?.[surveyId]?.status &&
    survey?.[surveyId]?.status !== "published" &&
    !previewing
  ) {
    return <InactiveSurveyMessage />;
  }

  if (
    (hasConditions !== true &&
      hasAnswerOptionLogic !== true &&
      (saveInProgress ||
        survey[surveyId] === undefined ||
        requestCompleted !== true)) ||
    (!alreadyTaken && !selectedLanguage) ||
    !autoSaveLoaded
  ) {
    return <Loading container={s.container} />;
  }

  //-------autosave ----------
  const onAutoSave = (dataToSave) => {
    if (anonymousAccess || previewing) return;
    const crntTime = new Date().getTime() / 1000;
    const crntSpendTime = (prevSpentTime || 0) + (crntTime - startTime.current);
    const data = {
      ...dataToSave,
      spent_time: crntSpendTime,
      currentLang: currentLang || selectedLanguage,
    };
    dispatch(autoSaveActions.saveData(surveyId, data, campaignDetails));
  };
  const resumeTypeHandler = (resumeType) => {
    if (resumeType === START_OVER) {
      dispatch(autoSaveActions.deleteData(surveyId));
    }
    setResumeType(resumeType);
    setAutoSaveModalOpen(false);
  };

  if (!previewing && autoSaveExist && autoSaveModalOpen && requestCompleted) {
    return (
      <AutoSaveModal
        resumeTypeHandler={resumeTypeHandler}
      />
    );
  }

  if (
    !welcomeDone &&
    (greetings !== null ||
      (survey[surveyId].isMultilingual &&
        (singleLangPreview !== null ||
          survey?.[surveyId]?.status === "published") &&
        !singleLangPreview)) &&
    !autoSaveExist
  ) {
    return (
      <RenderGreetings
        campaignDetails={campaignDetails}
        surveyId={surveyId}
        previewing={previewing}
        singleLangPrevie={singleLangPreview}
        currentLang={currentLang}
        welcomeDone={welcomeDone}
        setWelcomeDone={setWelcomeDone}
        selectedLanguage={selectedLanguage}
        setSelectedLanguage={setSelectedLanguage}
      />
    );
  }

  if (hasConditions || hasAnswerOptionLogic || hasBlocks || hasDependentEV) {
    return (
      <ConditionalSurvey
        hasDependentEV={hasDependentEV}
        hasConditions={hasConditions}
        hasAnswerOptionLogic={hasAnswerOptionLogic}
        hiddenAnswers={hiddenAnswers}
        previewing={previewing}
        currentLang={currentLang || selectedLanguage}
        save={save}
        onAutoSave={onAutoSave}
        resumeType={resumeType}
      />
    );
  }
  return (
    <>
      {surveyExperienceType === "guided" ? (
        <RenderSurveyInGuidedMode
          hasConditions={hasConditions}
          hasAnswerOptionLogic={hasAnswerOptionLogic}
          hasDependentEV={hasDependentEV}
          surveyId={surveyId}
          currentLang={currentLang || selectedLanguage}
          handleValidateQuestion={handleValidateQuestion}
          onAutoSave={onAutoSave}
          resumeType={resumeType}
        />
      ) : (
        <RenderSurveyInClassicMode
          hasConditions={hasConditions}
          surveyId={surveyId}
          currentLang={currentLang || selectedLanguage}
          handleValidateQuestion={handleValidateQuestion}
          onAutoSave={onAutoSave}
          resumeType={resumeType}
        />
      )}
    </>
  );
};

export default SurveyAnswer;
